; if (typeof culture == "undefined") culture = document.documentElement.lang || 'en-US';

var ShortDateFormat = {
    format: function (d) { return moment(d).locale(culture).format("L"); },
    formatUTC: function (d) { return moment(d).utc().locale(culture).format("L"); },
};
var DateFormat = {
    format: function (d) { return moment(d).locale(culture).format("ll"); },
    formatUTC: function (d) { return moment(d).utc().locale(culture).format("ll"); },
};
var DateTimeFormat = {
    format: function (d) { return moment(d).locale(culture).format("L LTS"); },
    formatUTC: function (d) { return moment(d).utc().locale(culture).format("L LTS"); },
    formatUTC_L_LT: function (d) { return moment(d).utc().locale(culture).format("L LT"); }
};

var UTCShortDateFormat = {
    format: function (d) { return moment.locale(culture).utc(d).format("L"); },
    formatUTC: function (d) { return moment(d).utc().locale(culture).format("L"); }
};
var UTCDateTimeFormat = {
    format: function (d) { return moment.locale(culture).utc(d).format("L LTS"); },
    formatUTC: function (d) { return moment(d).utc().locale(culture).format("L LTS"); }
};

var DateDurationFormat = {
    format: function () {
        var l10n;
        switch (culture) {
            case 'ru':
                l10n = {
                    year: "г. ",
                    month: "м. ",
                    days: "д.",
                    hours: "ч. ",
                    mins: "м.",
                    seconds: "с."
                };
                break;
            case 'en':
            case 'en-gb':
            default:
                l10n = {
                    year: "y. ",
                    month: "m. ",
                    days: "d.",
                    hours: "h. ",
                    mins: "m.",
                    seconds: "s."
                };
                break;
        }
        return function (duration) {
            var year = Math.floor(duration / 315576e5);
            duration -= year * 315576e5;
            var month = Math.floor(duration / 26298e5);
            duration -= month * 26298e5;
            var days = Math.floor(duration / 864e5);
            if (year) return year + l10n.year + (month ? month + l10n.month : '') + (days ? days + l10n.days : '');
            if (month) return month + l10n.month + (days ? days + l10n.days : '');
            duration -= days * 864e5;
            var hours = Math.floor(duration / 36e5);
            if (days) return days + " " + getWd(days);
            duration -= hours * 36e5;
            var mins = Math.floor(duration / 6e4);
            if (hours) return hours + l10n.hours + mins + l10n.mins;
            duration -= mins * 6e4;
            var seconds = Math.floor(duration / 1e3);
            return mins + l10n.mins + " " + seconds + l10n.seconds;
        };
    }()
};

var getWd = function () {
    switch (culture) {
        case 'ru':
            return function (n) {
                var a = n % 10;
                var a2 = (n / 10 | 0) % 10;
                if (a2 !== 1 && a === 1) return "день";
                if (a2 !== 1 && (a === 2 || a === 3 || a === 4)) return "дня";
                return "дней";
            };
        case 'es':
            return function (n) { return n === 1 ? "día" : "días"; };
        case 'pt':
            return function (n) { return n === 1 ? "dia" : "dias"; };
        case 'en':
        case 'en-gb':
        default:
            return function (n) { return n === 1 ? "day" : "days"; };
    }
}();